// extracted by mini-css-extract-plugin
export default {"card-modal":"Modal_card-modal__-5-3C","title":"Modal_title__37NVW","score-text-success":"Modal_score-text-success__QG-Gf","score-text-failure":"Modal_score-text-failure__5mJVr"};